<template>
  <PaginaAdministrar
    module-name="Tipos de Imagem"
    titulo="Tipos de Imagem"
    descricao="Gerencie os tipos de imagem disponíveis para as empresas. Cada tipo define restrições de dimensão, formato e proporção."
    endpoint-api="TipoImagemConfig"
    id-field="tipoImagem"
    :mostrar-botao-novo="true"
    :configuracao-grid="configuracaoGrid"
    :configuracao-busca="configuracaoBusca"
    @show-notification="(p) => emit('show-notification', p)"
  >
    <template #celula-acoes="{ item }">
      <button
        type="button"
        class="btn btn-sm btn-outline-primary me-1"
        @click="editar(item)"
        title="Editar tipo de imagem"
      >
        <i class="bi bi-pencil"></i>
      </button>
      <button
        type="button"
        class="btn btn-sm btn-outline-danger"
        @click="excluir(item)"
        :disabled="item.tipoImagem === 'AVULSO'"
        :title="item.tipoImagem === 'AVULSO' ? 'Tipo protegido' : 'Excluir tipo'"
      >
        <i class="bi bi-trash"></i>
      </button>
    </template>

    <template #celula-formatosPermitidos="{ item }">
      <code class="small">{{ item.formatosPermitidos || '-' }}</code>
    </template>

    <template #celula-obrigatorio="{ item }">
      <span :class="['badge', item.obrigatorio ? 'badge-ghost-warning' : 'badge-ghost-secondary']">
        {{ item.obrigatorio ? 'Sim' : 'Não' }}
      </span>
    </template>

    <template #celula-ativo="{ item }">
      <span :class="['badge', item.ativo ? 'badge-ghost-success' : 'badge-ghost-secondary']">
        {{ item.ativo ? 'Ativo' : 'Inativo' }}
      </span>
    </template>
  </PaginaAdministrar>

  <TipoImagemConfigCadastro
    v-if="mostrarCadastro"
    :item-para-editar="itemParaEditar"
    @item-atualizado="aoItemAtualizado"
    @cancelar="fecharCadastro"
    @show-notification="(p) => emit('show-notification', p)"
  />
</template>

<script setup>
import { ref } from 'vue'
import api from '@/services/api'
import PaginaAdministrar from '@/components/base/grid/PaginaAdministrar.vue'
import TipoImagemConfigCadastro from '@/components/configuracoes/tipoImagemConfig/TipoImagemConfigCadastro.vue'

const emit = defineEmits(['show-notification'])

const mostrarCadastro = ref(false)
const itemParaEditar = ref(null)
const recarregarGrid = ref(0)

const configuracaoGrid = {
  colunas: [
    { header: 'Código', dataField: 'tipoImagem', width: '15%' },
    { header: 'Nome Amigável', dataField: 'nomeAmigavel', width: '20%' },
    { header: 'Descrição', dataField: 'descricao', width: '25%' },
    { header: 'Formatos', dataField: 'formatosPermitidos', width: '15%', slotName: 'formatosPermitidos' },
    { header: 'Obrigatório', dataField: 'obrigatorio', width: '10%', slotName: 'obrigatorio' },
    { header: 'Ativo', dataField: 'ativo', width: '10%', slotName: 'ativo' }
  ],
  acoes: { width: '5%' }
}

const configuracaoBusca = {
  campos: [
    { model: 'tipoImagem', label: 'Código', tipo: 'text' },
    { model: 'nomeAmigavel', label: 'Nome Amigável', tipo: 'text' }
  ]
}

const editar = (item) => {
  itemParaEditar.value = item
  mostrarCadastro.value = true
}

const excluir = async (item) => {
  if (!confirm(`Deseja realmente excluir o tipo de imagem "${item.nomeAmigavel}"?`)) return
  try {
    await api.delete(`/TipoImagemConfig/${item.tipoImagem}`)
    emit('show-notification', { message: `Tipo "${item.nomeAmigavel}" excluído.`, type: 'success' })
    recarregarGrid.value++
  } catch (error) {
    const msg = error.response?.data?.message || 'Erro ao excluir tipo de imagem.'
    emit('show-notification', { message: msg, type: 'error' })
  }
}

const aoItemAtualizado = () => {
  fecharCadastro()
  recarregarGrid.value++
}

const fecharCadastro = () => {
  mostrarCadastro.value = false
  itemParaEditar.value = null
}
</script>
